 
import { EMOTION_ERRORS } from "../../common/constants/insightModule/emotionConstants.js";
import { WILLING_ERRORS } from "../../common/constants/insightModule/willingConstants.js";
import { POLARITY_ERRORS } from "../../common/constants/insightModule/polarityConstants.js";
import { SCORE_ERRORS } from "../../common/constants/insightModule/scoreConstants.js";
import { INSIGHT_URLS } from "../apiConfig.js";
import apiClient from "../apiInstance.js";

export const fetchWillingData = async ({startDate, endDate, channeltype}) => {
    try {
        const response = await apiClient.post(INSIGHT_URLS.GET_WILLING_DATA, {
            startDate,
            endDate,
            channeltype
        });
        return response.data;
    } catch (error) {
        console.error(WILLING_ERRORS.FETCH_WILLING_DATA_ERROR, error);
        throw error;
    }
};

export const fetchEmotionData = async ({startDate, endDate, channeltype}) => {
    try {
        const response = await apiClient.post(INSIGHT_URLS.GET_EMOTION_DATA, {
            startDate,
            endDate,
            channeltype
        });
        return response.data;
    } catch (error) {
        console.error(EMOTION_ERRORS.FETCH_EMOTION_DATA_ERROR, error);
        throw error;
    }
};

export const fetchPolarityData = async ({startDate, endDate, polarityType}) => {
    try {
        const response = await apiClient.post(INSIGHT_URLS.GET_POLARITY_DATA, { startDate, endDate, polarityType });
        return response.data;
    } catch (error) {
        console.error(POLARITY_ERRORS.FETCH_POLARITY_DATA_ERROR, error);
        throw error;
    }
};

export const fetchScoreData = async ({startDate, endDate, scoreType}) => {
    try {
        const response = await apiClient.post(INSIGHT_URLS.GET_SCORE_DATA, { startDate, endDate, scoreType });
        return response.data;
    } catch (error) {
        console.error(SCORE_ERRORS.FETCH_SCORE_DATA_ERROR, error);
        throw error;
    }
};

export const fetchAbandonText = async () => {
    try {
        const response = await apiClient.post(INSIGHT_URLS.GET_ABANDON_TEXT);
        return response.data;
    } catch (error) {
        console.error("Error fetching abandon text", error);
        throw error;
    }
};

export const fetchAbandonEmail = async () => {
    try {
        const response = await apiClient.post(INSIGHT_URLS.GET_ABANDON_EMAIL);
        return response.data;
    } catch (error) {
        console.error("Error fetching abandon email", error);
        throw error;
    }
};

export const fetchAbandonEventText = async () => {
    try {
        const response = await apiClient.post(INSIGHT_URLS.GET_ABANDON_EVENT_TEXT);
        return response.data;
    } catch (error) {
        console.error("Error fetching abandon event text", error);
        throw error;
    }
};

export const fetchAbandonEventEmail = async () => {
    try {
        const response = await apiClient.post(INSIGHT_URLS.GET_ABANDON_EVENT_EMAIL);
        return response.data;
    } catch (error) {
        console.error("Error fetching abandon event email", error);
        throw error;
    }
};

export const fetchResponseRateText = async () => {
    try {
        const response = await apiClient.post(INSIGHT_URLS.GET_RESPONSE_RATE_TEXT);
        return response.data;
    } catch (error) {
        console.error("Error fetching response rate text", error);
        throw error;
    }
};

export const fetchResponseRateEmail = async () => {
    try {
        const response = await apiClient.post(INSIGHT_URLS.GET_RESPONSE_RATE_EMAIL);
        return response.data;
    } catch (error) {
        console.error("Error fetching response rate email", error);
        throw error;
    }
};

export const fetchEmotionConversations = async ({ emotion, startDate, endDate, channeltype }) => {
    try {
      const response = await apiClient.post(INSIGHT_URLS.GET_EMOTION_CONVERSATIONS, {
        emotion, startDate, endDate, channeltype,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching emotion conversations", error);
      throw error;
    }
  };

  export const fetchPolarityConversations = async ({ polarity, startDate, endDate, channeltype }) => {
    try {
      const response = await apiClient.post(INSIGHT_URLS.GET_POLARITY_CONVERSATIONS, {
        polarity, startDate, endDate, channeltype,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching polarity conversations", error);
      throw error;
    }
  };

  export const fetchScoreConversations = async ({ score, startDate, endDate, channeltype }) => {
    try {
      const response = await apiClient.post(INSIGHT_URLS.GET_SCORE_CONVERSATIONS, {
        score, startDate, endDate, channeltype,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching score conversations", error);
      throw error;
    }
  };
  
  export const fetchWillingConversations = async ({ willing, startDate, endDate, channeltype }) => {
    try {
      const response = await apiClient.post(INSIGHT_URLS.GET_WILLING_CONVERSATIONS, {
        willing, startDate, endDate, channeltype,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching willing conversations", error);
      throw error;
    }
  };
  
  export const fetchAbandonEventConversations = async ({ event, startDate, endDate, channeltype }) => {
    try {
      const response = await apiClient.post(INSIGHT_URLS.GET_ABANDON_EVENT_CONVERSATIONS, {
        event, startDate, endDate, channeltype,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching abandon event conversations", error);
      throw error;
    }
  };
  
  export const fetchAbandonConversations = async ({ stage, startDate, endDate, channeltype }) => {
    try {
      const response = await apiClient.post(INSIGHT_URLS.GET_ABANDON_CONVERSATIONS, {
        stage, startDate, endDate, channeltype,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching abandon conversations", error);
      throw error;
    }
  };